
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAuth, registerPageStore } from './auth/auth';
import { RootStoreContext } from "./store/store_context";
import RootStore from './store/root_store';

// Один экземпляр store на всё приложение, auth-модулю нужна ссылка до render()
const rootStore = new RootStore();
registerPageStore(rootStore.pageStore);
initAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <RootStoreContext.Provider value={rootStore}>
    <App />
  </RootStoreContext.Provider>
);
